import { BCOFetchers } from "./bco.ts"
import { LWRNFetchers } from "./lwrn.ts"
import { PLTHFetchers } from "./plth.ts"

import type { SummaryRowConfig } from "../types/summaryRowTypes.ts"

const summaryConfig: Map<number, SummaryRowConfig> = new Map()
summaryConfig.set(2, BCOFetchers)
summaryConfig.set(4, PLTHFetchers)
summaryConfig.set(5, LWRNFetchers)

export default summaryConfig
